import User from "../../../types/user";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Dropdown, DropdownItem, Form } from "react-bootstrap";
import { containsFuzzy } from "../../../helpers/locale";
import { userCompare } from "../../../helpers/user";

export const UserDropdown = (props: {
  userMap: Map<number, User>;
  userID: number;
  setUserID: (set: number) => void;
  // shows a clear item that sets the user ID to 0 when someone is selected
  clearable?: boolean;
  disabled?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");

  return (
    <Dropdown className={`dropdown-bounded ${props.className ?? ""}`}>
      <Dropdown.Toggle variant="secondary" disabled={props.disabled}>
        {props.userMap.get(props.userID)?.displayName || <i>{t("general.none-selected")}</i>}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props.clearable && !!props.userID && (
          <>
            <Dropdown.Item key="clear" onClick={() => props.setUserID(0)}>
              ❌ <i>{t("schedules.fill.clear")}</i>
            </Dropdown.Item>
            <Dropdown.Divider />
          </>
        )}
        <Dropdown.Item
          key="filter"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Form.Control
            autoFocus
            size="sm"
            placeholder={t("search.hint")}
            onChange={(e) => setFilter(e.target.value)}
            value={filter}
          />
        </Dropdown.Item>
        {Array.from(props.userMap.values())
          .filter((u) => containsFuzzy(u.displayName, filter))
          .sort(userCompare)
          .map((u) => (
            <DropdownItem key={u.id} onClick={() => props.setUserID(u.id)}>
              {u.displayName}
            </DropdownItem>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
